module.exports = __webpack_public_path__ + "img/img12.34b4c2ad.svg";